<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="c1"></a>
</div>
<h4 class="chapnum">I.</h4>
<h4 class="chaptitle">W<span class="sc">AKE-UP</span> A<span class="sc">LARM</span></h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_c1.vue?2ffb8aee